import React, { useMemo } from 'react';
import { queryNoTracking } from "./components/services/DataService";
import { accentUtils } from './components/services/HelperService';
import { Helper, MessageTypes } from './components/services/MessageService';

export const query_Calendar_UserList = queryNoTracking("Calendar_UserList", undefined, undefined, undefined, { permanent: true, allowCaching: true });
export const query_User_TeamFilter = queryNoTracking("User_TeamFilter", undefined, undefined, undefined, { permanent: true, allowCaching: true });
export const query_Calendar_BusinessUnitList = queryNoTracking("Calendar_BusinessUnitList", undefined, undefined, undefined, { permanent: true, allowCaching: true });
export const query_GetScriptControlData = queryNoTracking("GetScriptControlData", undefined, undefined, undefined, { permanent: true, allowCaching: true });
export const query_UnitTypes = queryNoTracking("PL_UnitTypes")
export const query_DispatchSlots = queryNoTracking("DispatchSlots", undefined, undefined, undefined, { permanent: true, allowCaching: true });
// Whether the tenant uses pricing accounts at all; most do not, and for them the configurator
// skips the per-line account keyword lookup. The server sends PricingAccountsChanged when an
// account row is saved or deleted.
export const query_PricingAccounts_InUse = queryNoTracking("PricingAccounts_InUse", 0, undefined, undefined, { permanent: true, allowCaching: true });
export function registerPermanentQueries() {
    Helper.register('PermanentQueries', MessageTypes.PermanentCacheClear, clearPermanentQueryCache);
    Helper.register('PermanentQueries', MessageTypes.PricingAccountsChanged, clearPricingAccountsInUseCache);
}


export function clearPermanentQueryCache(e) {
    query_Calendar_UserList.clearCache();
    query_User_TeamFilter.clearCache();
    query_Calendar_BusinessUnitList.clearCache();    
    query_DispatchSlots.clearCache();
    clearPricingAccountsInUseCache();
}

export function clearPricingAccountsInUseCache() {
    query_PricingAccounts_InUse.clearCache();
}

/**
 * True unless the tenant is known to run no pricing accounts. Unknown (request failed, not yet
 * answered) is true so the full lookup still happens - skipping is only ever an optimisation.
 */
export async function pricingAccountsInUse() {
    try {
        const rows = await query_PricingAccounts_InUse.getAllWithCache();
        const row = accentUtils.isNull(rows) ? null : rows[0];
        return accentUtils.isNull(row) ? true : row.InUse !== false;
    } catch (e) {
        clearPricingAccountsInUseCache();
        return true;
    }
}

export function usePermanentQuery(query) {

    const [data, setData] = React.useState(null);


    React.useEffect(() => {

        query.getAllWithCache().then(res => {
            setData(res);
        });

    }, []);

    const result = useMemo(() => {
        return {
            data: accentUtils.isNull(data) ? [] : data.map(d => ({ ...d })),
            loading: accentUtils.isNull(data)
        };
    },[data]);

    return result;

}


